import { render } from "./Subjects.vue?vue&type=template&id=1fad249a"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__